import { Dictionary } from './../../core/model/dictionary';
import { SettingService } from './../../core/service/setting.service';
import { RuleType } from '../../channel/model/ruleSet';
import { FlowableService } from 'src/app/core/service/flowable.service';
import { User, Group } from 'src/app/user/model/user';
import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Channel } from 'src/app/channel/model/channel';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Validators, UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { UserService } from 'src/app/core/service/user.service';
import { CaseService } from 'src/app/core/service/case.service';
import { TranslateService } from '@ngx-translate/core';
import { reject, sortBy } from 'lodash';
import { TaskService } from 'src/app/core/service/task.service';
import { Guid } from 'guid-typescript';
import { AppComponent } from 'src/app/app.component';
import { Observable, forkJoin } from 'rxjs';
import { DeactivationGuarded } from 'src/app/core/routing/can-deactivate-guard.service';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';
import { GroupService } from 'src/app/core/service/group.service';
import { ToastrService } from 'ngx-toastr';
import { ChannelService } from 'src/app/core/service/channel.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';
import { SessionSetting } from 'src/app/core/model/session-setting';
import { ChannelCategoryList } from '../model/channelCategoryList';
import { ChannelCategoryService } from 'src/app/core/service/channel-category.service';
import { GridEventHandler } from 'src/app/core/model/grid-settings';
import { saveAs } from '@progress/kendo-file-saver';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

/**
 * Angular component for channel edit.
 */
@Component({
  selector: 'app-channel-edit',
  templateUrl: './channel-edit.component.html',
  styleUrls: ['./channel-edit.component.scss']
})
export class ChannelEditComponent implements OnInit, AfterViewChecked, DeactivationGuarded
{
  @ViewChildren(TooltipDirective) public tooltipDir: QueryList<TooltipDirective>;

  /**
   * Data model of the channel.
   */
  public channel: Channel = new Channel();

  /**
   * Angular form group for the channel.
   */
  public channelForm: any;

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  /**
   * Filtered list of staff candidates for drop-down.
   */
  public staffCandidatesFiltered: User[] = [];

  /**
   * Channel enrollment rules.
   */
  public entryRules: UntypedFormArray;

  /**
   * Channel update rules.
   */
  public updateRules: UntypedFormArray;

  /**
   * Channel tasks.
   */
  public tasks = [];

  /**
   * Channel goals.
   */
  public goals = [];

  /**
   * Channel Goal Types
   */
  public goalTypes: Array<{ text: string; value: string }> = [
    { text: 'Target days to close a case', value: 'targetDaysCloseCase' }
  ];

  public caseManagerAssignmentModes: Array<{ text: string; value: string }> = [];

  /**
   * Channel Goal form Group.
   */
  public goalForm: UntypedFormGroup = this.formBuilder.group({
    id: null,
    version: null,
    type: null,
    timeline: null,
    success: null,
    editing: true,
    isNew: false
  });

  /**
   * All sensitivities codes
   */
  public allSensitivities = [];

  /**
   * Filtered list of sensitivities for drop-down.
   */
  public sensitivitiesFiltered: Dictionary[] = [];

  /**
   * Current search term entered from a comboxbox
   */
  public searchTermSensivity: string;

  /**
   * Maximum number of items for sensitivity virtualization. This is to accelerate the DOM performance.
   */
  public virtualSensitivity: any = {
    itemHeight: 30
  };

  /**
   * The newly added channel goal.
   */
  public newGoalType: string = null;

  /**
   * Program staff.
   */
  public staff = [];

  /**
   * Kendo grid view for staff.
   */
  public staffGrid: GridViewManager;

  public pageSizes = [5, 10, 25, 50, 100];

  /**
   * Staff filtered for the update rules
   */
  public updateRulesStaffFiltered: Array<{ name: string; username: string; id: number; enabled: boolean }> = [];

  /**
   * The newly added staff member.
   */
  public newStaffMember = null;

  /**
   * Indicates whether the Case-edit dialog is opened.
   */
  public memberDialogOpened = false;

  /**
   * Indicates whether the Enroll a Test Memeber dialog is opened.
   */
  public enrollTestMemberConfirmationOpened = false;

  /**
   * Indicates if the page is loading.
   */
  public loading = true;

  /**
   * Revision rules update types selection.
   */
  public updateTypes: Array<{ text: string; value: string; disabled: boolean }> = [
    { text: 'Close Task(s)', value: 'CLOSE_TASKS', disabled: false },
    { text: 'Close Case(s)', value: 'CLOSE_CASES', disabled: false },
    { text: 'Close Conditional Wait', value: 'CLOSE_CONDITIONAL_WAIT', disabled: false },
    { text: 'Change Task(s) Priority', value: 'CHANGE_TASKS_PRIORITY', disabled: false },
    { text: 'Change Task(s) Assignee', value: 'CHANGE_TASKS_ASSIGNEE', disabled: false },
  ];

  public listPriorities: Array<{ id: string; text: string; value: number }>;

  /**
   * Outputs for conditional wait
   */
  public mapOutcomes = new Map<string, any>();

  public listOutcomes = [];

  /**
   * List of conditional waits
   */
  public conditionalWaits = [];

  /**
   * Channel Goal Max number of days.
   */
  public channelGoalMaxDays: number;

  /**
   * Filtered list of channel groups for drop-down.
   */
  public channelGroupsFiltered: Group[] = [];

  /**
   * Show the group member dialog
   */
  public showGroupMembersOpened = false;

  /**
   * When showGroupMembersOpened is true, indicate which view to show.
   */
  public groupByViewMode: string;

  /**
   * When showGroupMembersOpened is true, provide the staff list.
   */
  public groupByViewModeStaff: any;

  /**
   * When showGroupMembersOpened is true, provide the group list.
   */
  public groupByViewModeGroup: any;

  /**
   * Users
   */
  public channelUsers: User[] = [];

  /**
   * Patient label and formatted string
   */
  public patientLabel = {};
  public patientLabelLower = {};
  public patientLabelString: string;
  public recordDisabledText = '';

  public channelDetailsCollapsed = false;
  public channelCollapsed = false;
  public channelGoalsCollapsed = false;
  public workflowStatusInUse = false;

  /**
   * Delete Channel confirmation
   */
  public deleteDialogOpened = false;

  /**
   * Channel Categories for drop-down.
   */
  public channelCategories: ChannelCategoryList[] = [];

  /**
   * Filtered list of channel categories for drop-down.
   */
  public channelCategoriesFiltered: ChannelCategoryList[] = [];

  public bpmn: any;

  /**
   * Control if Program Lead have disabled access to workflow
   */
  public configureChannelDisabled = false;

  private deployedBpmn: any = null;

  /**
   * Channel status before deletion
   */
  private beforeDeleteStatus: string;

  /**
   * Users for the channel groups drop-down.
   */
  private channelGroups: Group[] = [];

  /**
   * Candidate users for channel staff drop-down.
   */
  private staffCandidates = [];

  /**
   * Staff for update rules
   */
  private updateRulesStaff: Array<{ name: string; username: string; id: number; enabled: boolean }> = [];

  /**
   * Channel ID.
   */
  private channelId: number;

  /**
   * Constructor.
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    private logger: NGXLogger,
    private route: ActivatedRoute,
    private router: Router,
    private messageHandlerService: MessageHandlerService,
    private userService: UserService,
    private caseService: CaseService,
    private taskService: TaskService,
    private flowableService: FlowableService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    private elem: ElementRef,
    private appComponent: AppComponent,
    private groupService: GroupService,
    private settingService: SettingService,
    private toastrService: ToastrService,
    private channelService: ChannelService,
    private dictionaryService: DictionaryService,
    private authenticationService: AuthenticationService,
    private channelCategoryService: ChannelCategoryService)
  {
    this.staffGrid = new GridViewManager(5);
  }

  /**
   * Getter for form control field category.
   */
  public get channelCategory(): UntypedFormControl
  {
    return this.channelForm.get('channelCategory');
  }

  /**
   * Getter for form control field caseManagerAssignmentMode.
   */
  public get caseManagerAssignmentMode(): UntypedFormControl
  {
    return this.channelForm.get('caseManagerAssignmentMode');
  }

  /**
   * Getter for form control field name.
   */
  public get name(): UntypedFormControl
  {
    return this.channelForm.get('name');
  }

  /**
   * Getter for form control field description.
   */
  public get description(): UntypedFormControl
  {
    return this.channelForm.get('description');
  }

  /**
   * Getter for form control field private.
   */
  public get private(): UntypedFormControl
  {
    return this.channelForm.get('private');
  }

  /**
   * Getter for form control field limitedEnrollment.
   */
  public get limitedEnrollment(): UntypedFormControl
  {
    return this.channelForm.get('limitedEnrollment');
  }

  /**
   * Getter for form control field limitedView.
   */
  public get limitedView(): UntypedFormControl
  {
    return this.channelForm.get('limitedView');
  }

  /**
   * Getter for form control field dashboardEnrollment.
   */
  public get dashboardEnrollment(): UntypedFormControl
  {
    return this.channelForm.get('dashboardEnrollment');
  }

  /**
   * Getter for form control field businessProcessId.
   */
  public get bpmId(): UntypedFormControl
  {
    return this.channelForm.get('bpmId');
  }

  /**
   * Getter for form control field groupsIds.
   */
  public get groups(): UntypedFormControl
  {
    return this.channelForm.get('groups');
  }

  /**
   * Getter for form control field users.
   */
  public get users(): UntypedFormControl
  {
    return this.channelForm.get('users');
  }

  public get sensitivities(): UntypedFormControl
  {
    return this.channelForm.get('sensitivities');
  }

  /**
  * Getter for form control field referral.
  */
  public get referral(): UntypedFormControl
  {
    return this.channelForm.get('referral');
  }

  public ngOnInit(): void
  {
    this.configureChannelDisabled = false;
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting: SessionSetting) =>
      {
        // Filter the available priorities based on the system settings
        const filteredListPriorities = this.taskService.listPriorities.filter(
          p => sessionSetting.taskPriorities.split(',').includes(p.id));
        this.listPriorities = filteredListPriorities;
        this.channelGoalMaxDays = sessionSetting.channelGoalMaxDays;
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
        this.patientLabelString = sessionSetting.patientLabel;
        this.patientLabelLower = { patientLabel: sessionSetting.patientLabel.toLowerCase() };

        // Enforce Program Leads access to worfklow
        if (sessionSetting.workflowRestrictedUsers !== '')
        {
          const currentUser = this.authenticationService.currentUser;
          if (currentUser && currentUser.role === 'ROLE_PROGRAM_LEAD')
          {
            const restrictedUsers = sessionSetting.workflowRestrictedUsers.split(',');
            restrictedUsers.every((id: string) =>
            {
              if (parseInt(id, 10) === currentUser.id)
              {
                this.configureChannelDisabled = true;
              }
              return !this.configureChannelDisabled;  // Stop iteration when set to false
            });
          }
        }
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    this.translate.get(['GOAL-TYPES', 'RULESET-UPDATE-TYPES', 'RECORD-DISABLED']).subscribe({
      next: (res) =>
      {
        let splitted = res['GOAL-TYPES'].split(',');
        for (let i = 0; i < splitted.length; i++)
        {
          this.goalTypes[i].text = splitted[i];
        }

        splitted = res['RULESET-UPDATE-TYPES'].split(',');
        for (let i = 0; i < splitted.length; i++)
        {
          if (this.updateTypes.length > i)
          {
            this.updateTypes[i].text = splitted[i];
          }
        }
        this.updateTypes = sortBy(this.updateTypes, ['text']);

        this.caseManagerAssignmentModes = this.caseService.caseManagerAssignmentModes;
        this.recordDisabledText = res['RECORD-DISABLED'];
      }
    });

    // Read all lookups
    const queries: any = [];
    queries.push(this.groupService.getGroups());
    queries.push(this.dictionaryService.getCachedSensitivities());
    queries.push(this.channelCategoryService.getCachedChannelCategories());
    queries.push(this.userService.getCachedUsers());

    forkJoin(queries).subscribe({
      next: (responseList: any) =>
      {
        // Set Channel Groups
        this.channelGroups = responseList[0];
        this.filterChannelGroups('');

        // Set Channel Sensitivities
        this.allSensitivities = responseList[1];
        this.filterSensitivities('');

        // Set Channel Categories
        this.channelCategories = responseList[2];
        this.filterChannelCategories('');

        // Set Channel Users
        this.channelUsers = responseList[3];
        this.route.params.forEach((params: Params) =>
        {
          if (params.id !== undefined)
          {
            this.channelId = +params.id;
            // Retrieve this channel from REST service
            this.getChannel();
          }
        });
      },
      error: (error) =>
      {
        // failed to retrieve channel, reset the view model and render with the error set for display
        this.messageHandlerService.displayError(error);
      }
    });
  }

  /**
   * Filters the sensitivities based on user input.
   */
  public filterSensitivities(filter: string): void
  {
    this.searchTerm = filter;
    this.sensitivitiesFiltered = this.allSensitivities
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Get Channel from Service
   */
  public getChannel(): void
  {
    this.loading = true;
    this.channelService.getChannel(this.channelId).subscribe({
      next: (data) =>
      {
        // Set channel data
        this.setChannelData(data);

        // Get the Tasks Definitions
        this.getTasks(data.deployedBpmKey);
        this.channelService.workflowStatusInUse(data.bpmKey).subscribe({
          next: (inUse) =>
          {
            this.workflowStatusInUse = inUse;
          }
        });
      },
      error: (error) =>
      {
        // failed to retrieve channel, reset the view model and render with the error set for display
        this.logger.error(error);
        this.messageHandlerService.displayError(error);
        this.channel = new Channel();
        this.buildForm();
      }
    });
  }

  /**
   * canDesactivate event implementation for monitoring if dirty changes and navigation without saving
   */
  public canDeactivate(): boolean | Observable<boolean> | Promise<boolean>
  {
    if (this.channelForm && this.channelForm.dirty)
    {
      this.appComponent.openUnsavedDialog();
      return this.appComponent.navigateAwaySelection;
    }
    else
    {
      return true;
    }
  }

  /**
   * Explicit change detection handler to avoid "expression-has-changed-after-it-was-checked-error".
   */
  public ngAfterViewChecked(): void
  {
    this.changeDetectorRef.detectChanges();
    const elements = this.elem.nativeElement.querySelectorAll('[role="option"]');
    for (let i = 0; i < elements.length; i++)
    {
      elements[i].setAttribute('style',
        'text-transform: none!important; font-family: "Open Sans",sans-serif;!important;letter-spacing:0!important;');
    }
  }

  /**
   * Navigates to rules edit.
   */
  public onEditRules(ruleSetId: number): void
  {
    if (this.channelId)
    {
      this.router.navigate([`/channel-edit/${this.channelId}/ruleset/${ruleSetId}/rules`]);
    }
  }

  /**
   * Remove update rules from selection.
   */
  public removeUpdateRule(i: number, id: number): void
  {
    const control = this.channelForm.controls.updateRules;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.channel.ruleSets = reject(this.channel.ruleSets, rejectedId);
    }
    (control as UntypedFormArray).removeAt(i);
    this.channelForm.markAsDirty(); // Must force mark as dirty when removing an update rule.
  }

  /**
   * Add a new update ruleset.
   */
  public onAddUpdateRules(): void
  {
    this.translate.get('NEW-UPDATE-CRITERIA-DEFAULT-NAME').subscribe({
      next: (value) =>
      {
        this.addUpdateRule(null, value, 0, 1, null, null, null, null, this.channel.id, null, null);
        this.channelForm.markAsDirty();
      }
    });
  }

  /**
   * Soft delete the channel.
   */
  public onDelete(): void
  {
    this.beforeDeleteStatus = this.channelForm.get('status').value;
    this.channelForm.get('active').setValue(false);
    this.setStatus('Deleted');
  }

  /**
   * Form submission event handler.
   */
  public onSubmit(): void
  {
    // If channel deletion, simply call deleteChannel.
    // This is a work around for deleting channel when all fields are disabled (because PUT failed).
    if (this.beforeDeleteStatus === 'Archived' && this.channelForm.value.status === 'Deleted')
    {
      this.channelService.deleteChannel(this.channelId).subscribe({
        next: () =>
        {
          this.messageHandlerService.displaySuccess('CHANNEL-DELETED-SUCCESSFULLY');
          this.getChannel();
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
      return;
    }

    this.private.enable();
    this.channel = this.channelForm.value;

    this.channel.goals = this.goals.map(goal => ({
      id: goal.id,
      version: goal.version,
      type: goal.type,
      success: goal.success,
      timeline: moment.duration(goal.timeline, 'days')
    }));

    // Post just ids for groups and users
    this.channel.groups = this.channel.groups.map((g: Group) => g.id);
    this.channel.users = this.channel.users.map((u: User) => u.id);

    // Set channel.ruleSets based on entryRules and updateRules
    this.channel.ruleSets = [];
    if (this.entryRules && this.entryRules.length > 0)
    {
      this.entryRules.value.forEach(r =>
      {
        this.channel.ruleSets.push(r);
      });
    }
    if (this.updateRules && this.updateRules.length > 0)
    {
      this.updateRules.value.forEach(r =>
      {
        // Work around to keep only taskIds otherwise kendo-multiselect with [valuePrimitive]="true" doesn't work.
        r.taskIds = (r.updateType === 'CLOSE_TASKS' ||
          r.updateType === 'CHANGE_TASKS_PRIORITY' ||
          r.updateType === 'CHANGE_TASKS_ASSIGNEE') ? r.taskIds.map(x => x.id) : [];
        r.priority = (r.updateType === 'CHANGE_TASKS_PRIORITY') ? r.priority.value : null;
        r.assigneeId = (r.updateType === 'CHANGE_TASKS_ASSIGNEE') ? r.assignee.id : null;
        r.conditionalWaitId = (r.updateType === 'CLOSE_CONDITIONAL_WAIT') ? r.conditionalWaitId.id : null;
        r.outcome = (r.updateType === 'CLOSE_CONDITIONAL_WAIT') ? r.outcome.outcome : null;

        this.channel.ruleSets.push(r);
      });
    }

    delete this.channel.entryRules;
    delete this.channel.updateRules;
    delete this.channel.newStaffMember;

    this.saveChannel();
  }

  /**
   * Save the current Channel
   */
  public saveChannel(): void
  {
    this.loading = true;

    this.channelService.saveChannel(this.channel, false, this.channelId).subscribe({
      next: (data) =>
      {
        this.setChannelData(data);
        // retrieve the modeler's BPMN
        if (data.appId !== null)
        {
          this.flowableService.getModel(data.appId).subscribe({
            next: (model) =>
            {
              this.flowableService.getModel(data.bpmId).subscribe({
                next: (bpmn) =>
                {
                  this.bpmn = bpmn;
                  const updatedApp = this.includeBpm(model, this.bpmn);
                  this.flowableService.updateApp(model.id, updatedApp).subscribe({
                    next: (appData) =>
                    {
                      if (appData.appDefinition !== null)
                      {
                        const key = appData.appDefinition.key;
                        const id = appData.appDefinition.id;
                        // step 3: get the deployed BPMN by the app's key.
                        this.flowableService.getDeployedBpmnByAppKey(key).subscribe({
                          next: (bpmnId) =>
                          {
                            this.deployedBpmn = bpmnId.data[0];
                            this.deployedBpmn.appId = id;
                            this.channelService.updateModel(this.channel.id, this.deployedBpmn).subscribe({
                              next: (channel) =>
                              {
                                this.channel = channel;
                              }
                            });
                          },
                          error: (error) =>
                          {
                            this.logger.error(error);
                          }
                        });
                      }
                      else if (appData.error)
                      {
                        this.logger.error(appData.errorDescription);
                        this.messageHandlerService.displayError('FAILED-TO-VALIDATE-PROCESS');
                      }
                    }
                  });
                }
              });
            }
          });
        }
        this.messageHandlerService.displaySuccess('CHANNEL-SAVED-SUCCESSFULLY');
        this.buildForm();
      },
      error: (error) =>
      {
        this.logger.error(error);

        // Error occurred during save, reset the model and display error message
        this.messageHandlerService.displayDirectMessage('error', error.message);
        this.channel = new Channel();
        this.buildForm();
      },
      complete: () =>
      {
        this.buildForm();
      }
    });
  }

  /**
   * Set the channel's status.
   *
   * @param status Channel status
   */
  public setStatus(status: string): void
  {
    this.channelForm.get('status').setValue(status);
    this.onSubmit();
  }

  /**
   * If true, disables the "Offline" button.
   */
  public disableOffline(): boolean
  {
    return this.channel.status === 'Offline' || this.channel.status === 'Archived' ||
      this.channel.active === false || !this.channelForm.valid || this.channel.bpmKey === undefined
      || this.channel.bpmKey === null || this.channel.deployedBpmKey === null || this.channel.deployedBpmKey === undefined;
  }

  /**
   * If true, disables the "Simulated" button.
   */
  public disableTest(): boolean
  {
    return this.channel.status === 'Simulated' || this.channel.status === 'Archived' ||
      this.channel.active === false || this.channel.id === null || !this.channelForm.valid || this.channel.bpmKey === undefined
      || this.channel.bpmKey === null || this.channel.deployedBpmKey === null || this.channel.deployedBpmKey === undefined;
  }

  /**
   * If true, the "Create Test Member" button is visible.
   */
  public visibleTestMember(): boolean
  {
    return this.channel.status === 'Simulated';
  }

  /**
   * If true, disables the "Create Test Member" button.
   */
  public disableTestMember(): boolean
  {
    return this.channelForm.dirty || this.channel.bpmId === null || this.disableFormControl();
  }

  /**
   * If true, disables the "Online" button.
   */
  public disableOnline(): boolean
  {
    return this.channel.status === 'Online' || this.channel.status === 'Archived' ||
      this.channel.active === false || this.channel.id === null || !this.channelForm.valid || this.channel.bpmKey === undefined
      || this.channel.bpmKey === null || this.channel.deployedBpmKey === null || this.channel.deployedBpmKey === undefined;
  }

  /**
   * If true, disables the "Archived" button.
   */
  public disableRetire(): boolean
  {
    return this.channel.status === 'Offline' || this.channel.status === 'Archived' ||
      this.channel.id === null || this.channel.active === false || !this.channelForm.valid || this.channel.bpmKey === undefined
      || this.channel.bpmKey === null || this.channel.deployedBpmKey === null || this.channel.deployedBpmKey === undefined;
  }

  /**
   * If true, disables the "Delete" button.
   */
  public disableDelete(): boolean
  {
    return this.channel.status === 'Online' || this.channel.status === 'Deleted' ||
      this.channel.active === false || !this.channelForm.valid;
  }

  /**
   * If true, disables the "Save" button.
   */
  public disableSave(): boolean
  {
    return this.channel.status === 'Archived' ||
      this.channel.active === false || !this.channelForm.valid || !this.channelForm.dirty;
  }

  /**
   * Filters the channel staff based on user input.
   */
  public filterStaffCandidates(filterValue: string): void
  {
    this.searchTerm = filterValue;
    this.staffCandidatesFiltered = this.staffCandidates
      .filter(user => user.name.toLowerCase().includes(filterValue.toLowerCase()));
  }

  /**
   * Filters the channel groups based on user input.
   */
  public filterChannelGroups(filterValue: string): void
  {
    this.searchTerm = filterValue;
    this.channelGroupsFiltered = sortBy(this.channelGroups
      .filter(group => group.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Determines if a field in the channel FormGroup is valid.
   */
  public formFieldInvalid(field: string): boolean
  {
    return this.channelForm.controls[field].touched && this.channelForm.controls[field].invalid;
  }

  /**
   * Navigates to the business process modeler.
   */
  public goToModeler(): void
  {
    this.flowableService.getModel(this.bpmId.value).subscribe({
      next: (data) =>
      {
        if (data == null)
        {
          this.translate.get('MODEL-NOT-FOUND').subscribe({
            next: (res: string) =>
            {
              this.messageHandlerService.displayDirectMessage('error', res);
            }
          });
        }
        else
        {
          this.router.navigateByUrl(
            '/channels/' + this.channelId + '/modeler/' + this.bpmId.value
          );
        }
      },
      error: (error) =>
      {
        this.translate.get('MODEL-NOT-FOUND').subscribe({
          next: (res: string) =>
          {
            this.messageHandlerService.displayDirectMessage('error', res);
            this.logger.error(error);
          }
        });
      }
    });
  }

  /**
   * Initiate a FormGroup for business process, and open the form dialog.
   */
  public createProcessModel(): void
  {
    // Build name default based on channel name
    const bpm = {
      name: this.channelService.buildBPMDefaultName(this.channel.name),
      key: Guid.create().toString(),
      description: this.channel.name,
      modelType: 0,
    };

    this.flowableService.createProcess(bpm).subscribe({
      next: (data) =>
      {
        this.channelForm.controls.bpmId.setValue(data.id);
        this.channelForm.controls.bpmKey.setValue(data.key);
        this.channelForm.controls.bpmName.setValue(data.name);
        this.onSubmit(); // save the channel with the new BPM id and key.
        this.goToModeler();
      },
      error: (error) =>
      {
        this.logger.error(error);
        this.messageHandlerService.displayDirectMessage('error', error.message);
      }
    });
  }

  /**
   * Delete Staff from Channel.
   *
   * @param user User to delete.
   */
  public deleteStaff(user: User): void
  {
    this.staff = this.staff.filter(u => u.id !== user.id);
    this.staffGrid.setData(this.staff);
    this.setStaffCandidates();

    this.userService.removeUserFromChannel(user.id, this.channel.id).subscribe({
      next: (data) =>
      {
        this.setChannelData(data);
        this.users.setValue(this.channel.users);    // Must reset form too in case of other changes to save
        this.messageHandlerService.displaySuccess('STAFF-DELETE-SUCCESSFULLY');
      }
    });
  }

  /**
   * Staff cancel handler
   */
  public staffCancelHandler(event: GridEventHandler): void
  {
    event.sender.closeRow(event.rowIndex);
  }

  /**
   * Staff add handler
   */
  public staffAddHandler(event: GridEventHandler): void
  {
    this.newStaffMember = null;
    this.setStaffCandidates();
    event.sender.addRow(new UntypedFormGroup({ editing: new UntypedFormControl(true) }));
  }

  /**
   * This method set the available staff candidates for selection. This is being called on add and delete method.
   */
  public setStaffCandidates(): void
  {
    const groups = this.groups.value;
    // Users from groups are removed from available selection.
    const groupUsers = this.getSelectedUsersFromGroups(groups, this.channelGroups);
    this.staffCandidates = sortBy(this.channelUsers.filter(u =>
      !this.staff.map(m => m.id).includes(u.id) &&
      !groupUsers.map(m => m.id).includes(u.id)), ['name']);
    this.filterStaffCandidates('');
  }

  /**
   * Staff save handler
   */
  public staffSaveHandler(event: GridEventHandler): void
  {
    event.sender.closeRow(event.rowIndex);
    this.addStaff(this.newStaffMember);

    this.userService.addUserToChannel(this.newStaffMember.id, this.channel.id).subscribe({
      next: (data) =>
      {
        this.setChannelData(data);
        this.users.setValue(this.channel.users);    // Must reset form too in case of other changes to save
        this.messageHandlerService.displaySuccess('STAFF-SAVED-SUCCESSFULLY');
      }
    });
  }

  /**
   * Goals grid row editing event handler.
   */
  public goalEditHandler(event: GridEventHandler): void
  {
    this.newGoalType = event.dataItem.type;
    this.goalForm = this.formBuilder.group(
      {
        id: event.dataItem.id,
        version: event.dataItem.version,
        type: event.dataItem.type,
        success: event.dataItem.success,
        timeline: [{ value: event.dataItem.timeline, disabled: false }, Validators.required],
        editing: true,
        isNew: false
      }
    );
    event.sender.editRow(event.rowIndex, this.goalForm);
    event.dataItem.editing = true;
  }

  /**
   * Event handler for goals grid add.
   */
  public goalAddHandler(event: GridEventHandler): void
  {
    this.newGoalType = 'targetDaysCloseCase';
    this.goalForm = this.formBuilder.group(
      {
        id: null,
        version: null,
        type: this.newGoalType,
        success: null,
        timeline: [{ value: null, disabled: false }, Validators.required],
        editing: true,
        isNew: true
      }
    );
    event.sender.addRow(this.goalForm);
  }

  /**
   * Event handler for goals grid save.
   */
  public goalSaveHandler(event: GridEventHandler): void
  {
    event.sender.closeRow(event.rowIndex);
    event.dataItem.editing = false;
    this.goalForm.value.editing = false;

    // Get goel from form value
    const currentGoal = this.goalForm.value;

    if (currentGoal.isNew)
    {
      // Set type if new. On edit, we can't change the type.
      currentGoal.type = this.newGoalType;
      this.goals.push(currentGoal);
    }

    // Update timeline for the selected goal type
    const goalIndex = this.goals.findIndex(g => g.type === currentGoal.type);
    this.goals[goalIndex].timeline = currentGoal.timeline;
    this.goals[goalIndex].success = currentGoal.success;

    // Update channel goals prior update
    this.channel.goals = this.goals.map(goal => ({
      id: goal.id,
      version: goal.version,
      type: goal.type,
      success: goal.success,
      timeline: moment.duration(goal.timeline, 'days')
    }));

    const goalToUpdate = this.channel.goals.find(g => g.type === currentGoal.type);
    this.channelService.saveChannelGoal(goalToUpdate, currentGoal.isNew, this.channel.id)
      .subscribe({
        next: (data) =>
        {
          // Update id if new only
          if (currentGoal.isNew)
          {
            this.goals[goalIndex].id = data.id;
          }
          this.goals[goalIndex].version = data.version;
          this.messageHandlerService.displaySuccess('GOAL-SAVED-SUCCESSFULLY');
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
  }

  /**
   * Cancel channel goal add or edit
   *
   * @param sender Grid
   * @param rowIndex Grid Row index
   * @param dataItem Grid data item
   */
  public goalCancelHandler(event: GridEventHandler): void
  {
    event.sender.closeRow(event.rowIndex);
    event.dataItem.editing = false;
  }

  /**
   * Delete a channel goal.
   *
   * @param dataItem Goal item to delete.
   */
  public goalDeleteHandler(dataItem: any): void
  {
    this.channelService.deleteChannelGoal(this.channel.id, dataItem.id).subscribe({
      next: () =>
      {
        this.goals = this.goals.filter(x => x.type !== dataItem.type);
        this.messageHandlerService.displaySuccess('GOAL-DELETE-SUCCESSFULLY');
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Event called when Update Type selection is changed.
   */
  public handleUpdateTypeChange(updateType: string, index: number): void
  {
    // Set TaskIds control validator
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const taskIdsControl = this.channelForm.controls.updateRules['controls'][index].get('taskIds');
    if (taskIdsControl)
    {
      taskIdsControl.setValidators(
        (updateType === 'CLOSE_TASKS' ||
          updateType === 'CHANGE_TASKS_ASSIGNEE' ||
          updateType === 'CHANGE_TASKS_PRIORITY') ? [Validators.required] : []);
      taskIdsControl.updateValueAndValidity();
    }

    // Set Assignee control validator
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const assigneeControl = this.channelForm.controls.updateRules['controls'][index].get('assignee');
    if (assigneeControl)
    {
      assigneeControl.setValidators((updateType === 'CHANGE_TASKS_ASSIGNEE') ? [Validators.required] : []);
      assigneeControl.updateValueAndValidity();
    }

    // Set Priority control validator
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const priorityControl = this.channelForm.controls.updateRules['controls'][index].get('priority');
    if (priorityControl)
    {
      priorityControl.setValidators((updateType === 'CHANGE_TASKS_PRIORITY') ? [Validators.required] : []);
      priorityControl.updateValueAndValidity();
    }

    if (updateType === 'CHANGE_TASKS_ASSIGNEE' || updateType === 'CHANGE_TASKS_PRIORITY')
    {
      this.setUpdateRulesStaff();
    }
  }

  /**
   * Disable buttons based on channel status.
   */
  public disableFormControl(): boolean
  {
    return this.channel.status === 'Deleted' || this.channel.status === 'Archived' || !this.channel.active;
  }

  /**
   * Disable CLOSE_TASKS option if current Program is a template.
   *
   * @param itemArgs Item object
   */
  public updateTypeItemDisabled(itemArgs: { dataItem: string; index: number }): boolean
  {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    return itemArgs.dataItem['disabled'];
  }

  /**
   * Called when updateTypeItem combox box open.
   */
  public updateTypeItemOpen(): void
  {
    const obj = this.updateTypes.find(x => x.value === 'CLOSE_TASKS');
    obj.disabled = this.channel.status === 'Template';  // Disable close Tasks for Templates
  }

  /**
   * Return the Channel Status Key for translation.
   *
   * @param channelStatus Current channel status.
   */
  public getChannelStatusKey(channelStatus: string): string
  {
    return this.channelService.getChannelStatusKey(channelStatus);
  }

  /**
   * Get Goal Type Display Text.
   *
   * @param goalType Channel Goal Type.
   */
  public getGoalTypeText(goalType: string): string
  {
    const goal = this.goalTypes.find(g => g.value === goalType);
    return goal && goal.text ? goal.text : goalType;
  }

  /**
   * Check if Channel Goal is already added.
   */
  public addGoalDisabled(): boolean
  {
    return this.goals.findIndex(g => g.type === 'targetDaysCloseCase') >= 0;
  }

  /**
   * Method to indicate if the channel group is selected.
   * This is use to set the custom checkbox of the kendo-multiselect.
   *
   * @param filterItem Filter property name
   * @param itemValue Item value id
   */
  public isGroupSelected(filterItem: string, itemValue: any): boolean
  {
    return this[filterItem].value && this[filterItem].value.map((m: Group) => m.id).includes(itemValue);
  }

  /**
   * Disable inactive items from group drop-down.
   *
   * @param itemArgs Item object
   */
  public groupItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Set the item enable/disable state for the staff dropdown.
   *
   * @param itemArgs Item object
   * @returns boolean
   */
  public staffItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.enabled && !itemArgs.dataItem.inRegistration;
  }

  /**
   * Before creating a Test Case, ask for a confirmation.
   */
  public createTestMember(): void
  {
    this.enrollTestMemberConfirmationOpened = true;
  }

  /**
   * Create a Test Case with a Test Member
   */
  public createTestMemberAction(): void
  {
    this.caseService.getMemberDataFromMultipleSources(this.channel.id).subscribe({
      next: (responseList) =>
      {
        const now = moment();
        const firstName = `Test ${now.format('YYYYMMDD')}_${now.toDate().getTime()}`;
        const lastName = 'Disregard';
        const memberFullName = `${firstName} ${lastName}`;
        const genders = responseList[0];
        const states = responseList[1];
        const countries = responseList[2];
        const managers = responseList[3];

        if (managers.length === 0)
        {
          this.enrollTestMemberConfirmationOpened = false;
          this.messageHandlerService.displayError('ENROLL-TEST-MISSING-GROUP-OR-STAFF');
          return;
        }

        const randomManagerIndex = Math.floor((Math.random() * managers.length) + 1);
        const nyState = states.find(x => x.code === 'NY');

        const newCase =
        {
          testCase: true,
          name: `${firstName} ${lastName}`,
          channel:
          {
            id: this.channel.id
          },
          member:
          {
            testMember: true,
            name:
            {
              givenName: firstName,
              familyName: lastName,
              middleName: null,
              fullName: `${firstName} ${lastName}`,
              preferredName: `${firstName} ${lastName}`
            },
            dateOfBirth: moment().subtract('25', 'year').toDate(),
            gender: genders.length > 0 ? genders[0].id : null,
            contact: {
              homePhoneNumber: null,
              cellPhoneNumber: null,
              email: null
            },
            address:
            {
              streetLine: '1 Anyhow Lane',
              city: 'Wilton',
              state: nyState,
              postalCode: null,
              country: countries[0]
            }
          },
          manager:
          {
            id: managers[randomManagerIndex - 1].id
          },
          priority: 50
        };

        // Log new Case to console
        this.logger.info(newCase);

        // call service to create case
        this.caseService.createCase(newCase).subscribe({
          next: (data) =>
          {
            const newCaseId = data.id;
            this.translate.get('ENROLL-TEST-MEMBER-SUCCESS').subscribe({
              next: (res) =>
              {
                this.toastrService.success(
                  res
                    .replace('{{value}}', memberFullName)
                    .replace('{{patientLabel}}', this.patientLabelString), null,
                  {
                    enableHtml: true,
                    timeOut: 5000
                  })
                  .onTap.subscribe({
                    next: () =>
                    {
                      this.openCase(newCaseId);
                    }
                  });
              }
            });
          },
          error: () =>
          {
            this.messageHandlerService.displayError('CASE-SAVE-ERROR');
            this.enrollTestMemberConfirmationOpened = false;
          },
          complete: () =>
          {
            this.enrollTestMemberConfirmationOpened = false;
          }
        });
      }
    });
  }

  /**
   * Show the member of the selected groups.
   */
  public showGroupMember(): void
  {
    this.groupByViewMode = 'group';

    // Prepare Grouping by Staff
    let users = [];
    this.groups.value.forEach((g: any) =>
    {
      const filteredUsers = g.users.filter((u: any) => !u.deleted);
      g.users = sortBy(filteredUsers, (x) => x.name);
      g.users.forEach((u: any) =>
      {
        if (users.find(x => x.user.id === u.id) === undefined)
        {
          users.push({ user: u, groups: [] });
          users = sortBy(users, (x) => x.user.name);
        }
        const foundUser = users.find(x => x.user.id === u.id);
        if (foundUser.groups.findIndex(x => x.id === g.id) === -1)
        {
          foundUser.groups.push(g);
        }
      });
    });

    this.groupByViewModeStaff = sortBy(users, (x) => x.user.name);
    this.groupByViewModeGroup = sortBy(this.groups.value, ['name']);
    this.showGroupMembersOpened = true;
  }

  /**
   * Check if groups have selection.
   *
   * @returns boolean Returns true if there is groups selected.
   */
  public isGroupsSelected(): boolean
  {
    return (this.groups && this.groups.value.length > 0);
  }

  /**
   * Set the update rules staff for the update rules drop-down when selecting the assignee.
   */
  public setUpdateRulesStaff(): void
  {
    this.userService.getUsersByChannelGroups(this.channel.id).subscribe({
      next: (users) =>
      {
        this.updateRulesStaff = users.map((p: any) => ({ name: p.name, username: p.username, id: p.id, enabled: p.enabled }));
        this.updateRulesStaffFilter('');
      }
    });
  }

  /**
   * Filter handler for update rules assignee dropdown.
   *
   * @param value User input.
   */
  public updateRulesStaffFilter(value: string): void
  {
    this.searchTerm = value;
    this.updateRulesStaffFiltered = sortBy(this.updateRulesStaff.filter(p => p.name.toLowerCase().includes(value.toLowerCase())), ['name']);
  }

  /**
   * This method navigate to a specific Case Id
   *
   * @param caseId Case Id to navigate to.
   */
  public openCase(caseId: number): void
  {
    this.router.navigate([`/case/${caseId}`]);
  }

  public loadOutcomes(conditionalWait: any): void
  {
    this.mapOutcomes.set(conditionalWait.id, conditionalWait.outcomes);
    this.listOutcomes = conditionalWait.outcomes;
  }

  public exportModel(): void
  {
    if (this.channel.appId !== undefined && this.channel.appId !== null && this.channel.bpmId !== undefined && this.channel.bpmId !== null)
    {
      this.flowableService.generateZip(this.channel.appId, this.channel.bpmId).subscribe({
        next: (data) =>
        {
          saveAs(`data:${data.mimeType};base64,${data.content}`, this.channel.bpmName);
        }
      });
    }
  }

  public backToProgramEdit(): void
  {
    this.router.navigateByUrl(`/program-edit/${this.channel.program.id}`);
  }

  /**
   * If bpmId is null that mean we must craete the Business Process first.
   * Then createProcemModel will navigate to the Modeler after creation.
   * If the bpmId is not null, the we can navigate to the Modeler immedialty.
   *
   * @param bpmId Business Process Id
   */
  public configureChannel(bpmId: string): void
  {
    if (bpmId === null)
    {
      this.createProcessModel();
    }
    else
    {
      this.goToModeler();
    }
  }

  /**
   * Closes a component
   *
   * @param component Name of component to be closed.
   */
  public close(component: string): void
  {
    this[component + 'Opened'] = false;
  }

  /**
   * Opens a component
   *
   * @param component Name of component to be opened.
   */
  public open(component: string): void
  {
    this[component + 'Opened'] = true;
  }

  /**
   * Button action handler.
   *
   * @param confirm Confirm the action: yes/no
   */
  public deleteAction(confirm: boolean): void
  {
    if (confirm)
    {
      this.onDelete();
    }
    // post-deletion cleanup and refresh grid
    this.close('deleteDialog');
  }

  public checkChannelStatus(): void
  {
    if (this.channel.status === 'Simulated')
    {
      this.messageHandlerService.displayWarning('CANNOT-TEST-CHANNEL-FEATURE');
    }
    else
    {
      this.memberDialogOpened = true;
    }
  }

  public validateKey(e: KeyboardEvent): void
  {
    TextProcessor.validateKey(e);
  }

  /**
   * Filters the channel categories based on user input.
   */
  public filterChannelCategories(filterValue: string): void
  {
    this.channelCategoriesFiltered = sortBy(this.channelCategories
      .filter(category => category.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Disable inactive items from drop-down.
   *
   * @param itemArgs Item object
   */
  public categoryItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  public onMemberAdded(): void
  {
    this.memberDialogOpened = false;
  }

  /**
   * Include the bpmn in the flowable app and return the app object.
   *
   * @param flowableApp Flowable app
   * @param bpmn BPMN object
   */
  public includeBpm(flowableApp, bpmn): any
  {
    return {
      appDefinition:
      {
        id: flowableApp.id,
        name: flowableApp.name,
        key: flowableApp.key,
        description: flowableApp.description,
        version: flowableApp.version,
        definition: // this is the BPM
        {
          models: [
            bpmn // we only support a single process for each channel
          ],
          theme: 'theme-1', // default theme color
          icon: 'glyphicon-asterisk' // default icon
        }
      },
      publish: true // must have this property to publish the app.
    };
  }

  public setRecordStateText(dataItem: any): string
  {
    if (dataItem && !dataItem.enabled)
    {
      return this.recordDisabledText;
    }
    else
    {
      return '';
    }
  }

  public disabledDashboardEnrollment(): boolean 
  {
    const isReferralChannelCategory = this.channelCategory.value && this.channelCategory.value.name.toLowerCase().includes('referral');
    return (this.disableFormControl() || isReferralChannelCategory || this.private.value);
  }

  public disablePrivate(): boolean 
  {
    return (this.disableFormControl() || this.referral.value);
  }

  public showTooltip(e: ElementRef, tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.toggle(e, true); // Show the tooltip
    }
  }

  public hideTooltip(tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.hide(); // Show the tooltip
    }
  }

  /**
   * Method to set channel's data. Some manipulations are required.
   *
   * @param data Channel data.
   */
  private setChannelData(data: any, isSetFromTemplate = false): void
  {
    if (!isSetFromTemplate) // When copied from a Template, goals will be copied on the server.
    {
      this.channel = data;
      this.setGoals(data.goals);
    }
    this.setChannelUsers(data.users, this.channelUsers);
    this.setChannelGroups(data.groups, this.channelGroups);
  }

  /**
   * Get the Tasks Definitions based on provided BPM key
   *
   * @param bpmKey Business Process Key
   */
  private getTasks(bpmKey: string): void
  {
    if (!bpmKey)
    {
      this.tasks = [];
      this.buildForm();
    }
    else
    {
      this.taskService.getTaskDefinitionForKey(bpmKey).subscribe({
        next: (data) =>
        {
          data.forEach(d =>
          {
            if (d.assignee === 'SYSTEM')
            {
              this.conditionalWaits.push(d);
            }
            else
            {
              this.tasks.push(d);
            }
          });
          this.buildForm();
        }
      });
    }
  }

  /**
   * Create a ruleset control being used by the form.
   *
   * @param id Entry Rule Id
   * @param name Entry Rule Name
   * @param version Entry Rule version number returned by service-layer
   * @param type Entry Rule Type. 0=Enroll (entry ruleset), 1=Update (revision ruleset)
   * @param taskIds List of TaskIds associated with the update ruleset
   * @param assignee Assignee for the update ruleset
   * @param priority Priority for the update ruleset
   * @param channelId Current Channel id
   * @returns formBuildGroup
   */
  private createItem(id: number, name: string, version: number, type: RuleType, updateType: string,
    taskIds: Array<number>, assignee: any, priority: any, channelId: number, conditionalWait: any, outcome: any): UntypedFormGroup
  {
    let updateTypeValidator = [];
    let taskIdsValidator = [];
    let assigneeValidator = [];
    let priorityValidator = [];
    let conditionalWaitValidator = [];
    let outcomeValidator = [];

    if (type === RuleType.update)
    {
      updateTypeValidator = [Validators.required];
    }

    switch (updateType)
    {
      case 'CLOSE_TASKS':
        taskIdsValidator = [Validators.required];
        break;
      case 'CHANGE_TASKS_ASSIGNEE':
        assigneeValidator = [Validators.required];
        taskIdsValidator = [Validators.required];
        break;
      case 'CHANGE_TASKS_PRIORITY':
        priorityValidator = [Validators.required];
        taskIdsValidator = [Validators.required];
        break;
      case 'CLOSE_CONDITIONAL_WAIT':
        conditionalWaitValidator = [Validators.required];
        outcomeValidator = [Validators.required];
        break;
    }

    // For Entry Rules there is no taskIds, just set an empty array.
    if (!taskIds)
    {
      taskIds = [];
    }

    const group: any = {};
    group.id = id;
    group.name = [{ value: name, disabled: this.disableFormControl() }, Validators.required];
    group.version = version;
    group.type = type;
    group.updateType = [{ value: updateType, disabled: this.disableFormControl() }, updateTypeValidator];
    group.taskIds = [taskIds, taskIdsValidator];
    group.channelId = channelId;
    group.assignee = [assignee, assigneeValidator];
    group.priority = [priority, priorityValidator];
    group.conditionalWaitId = [conditionalWait, conditionalWaitValidator];
    group.outcome = [outcome, outcomeValidator];

    return this.formBuilder.group(group);
  }

  /**
   * Add channel ruleset entry rules.
   *
   * @param id Entry Rule Id
   * @param name Entry Rule Name
   * @param version Entry Rule version number returned by service-layer
   * @param type Entry Rule Type. 0=Enroll (entry ruleset), 1=Update (revision ruleset)
   * @param channelId Current Channel Id
   */
  private addEntryRule(id: number = null, name = '', version = 0, type: RuleType, channelId: number): void
  {
    this.entryRules = this.channelForm.get('entryRules') as UntypedFormArray;
    this.entryRules.push(this.createItem(id, name, version, type, null, null, null, null, channelId, null, null));
  }

  /**
   * Add channel ruleset update rules.
   *
   * @param id Entry Rule Id
   * @param name Entry Rule Name
   * @param version Entry Rule version number returned by service-layer
   * @param type Entry Rule Type. 0=Enroll (entry ruleset), 1=Update (revision ruleset)
   * @param updateType RuleSet Update Type. 0=CLOSE_TASKS, 1=CLOSE_CASES
   * @param taskIds List of TaskIds associated with the update ruleset
   * @param channelId Current Channel Id
   */
  private addUpdateRule(id: number = null, name = '', version = 0, type: RuleType, updateType: string,
    taskIds: Array<number>, assignee: any, priority: any, channelId: number, conditionalWaitId: any, outcome: any): void
  {
    this.updateRules = this.channelForm.get('updateRules') as UntypedFormArray;
    this.updateRules.push(this.createItem(id, name, version, type, updateType, taskIds, assignee, priority,
      channelId, conditionalWaitId, outcome));
  }

  /**
   * Initializes the channel FormGroup.
   */
  private buildForm(): void
  {
    this.channelForm = this.formBuilder.group({
      id: this.channel.id,
      name: [{ value: this.channel.name, disabled: this.disableFormControl() }, [Validators.required, Validators.maxLength(255)]],
      description: [{ value: this.channel.description, disabled: this.disableFormControl() }, Validators.required],
      private: [{ value: this.channel.private, disabled: this.disableFormControl() }],
      limitedEnrollment: [{ value: this.channel.limitedEnrollment, disabled: this.disableFormControl() }],
      limitedView: [{ value: this.channel.limitedView, disabled: this.disableFormControl() }],
      dashboardEnrollment: [{ value: this.channel.dashboardEnrollment, disabled: this.disableFormControl() }],
      version: this.channel.version,
      comments: { value: this.channel.comments, disabled: this.disableFormControl() },
      status: this.channel.status,
      active: this.channel.active,
      entryRules: this.formBuilder.array([]),
      updateRules: this.formBuilder.array([]),
      appId: this.channel.appId,
      bpmId: this.channel.bpmId,
      bpmKey: this.channel.bpmKey,
      bpmName: { value: this.channel.bpmName, disabled: this.disableFormControl() },
      newStaffMember: { id: null, name: null },
      groups: [{ value: sortBy(this.channel.groups, ['name']), disabled: this.disableFormControl() }],
      users: [{ value: this.channel.users, disabled: this.disableFormControl() }],
      program: this.channel.program,
      channelCategory: [{ value: this.channel.channelCategory, disabled: this.disableFormControl() }],
      caseManagerAssignmentMode: [{ value: this.channel.caseManagerAssignmentMode, disabled: this.disableFormControl() }],
      sensitivities: [{ value: this.channel.sensitivities, disabled: this.disableFormControl() }],
      referral: [{ value: this.channel.referral, disabled: this.disableFormControl() }],
    });

    // Set ruleset the channel
    let entryRuleFound = false;
    if (this.channel.ruleSets)
    {
      // Load entry ruleset
      const entryRules = this.channel.ruleSets.filter(x => x.type === 'Enroll');
      entryRules.forEach(d =>
      {
        this.addEntryRule(d.id, d.name, d.version, RuleType.enroll, this.channel.id);
        entryRuleFound = true;
      });
      // Load update rulesets
      const updateRules = this.channel.ruleSets.filter(x => x.type === 'Update');
      if (updateRules.length > 0)
      {
        this.setUpdateRulesStaff();
      }
      sortBy(updateRules, ['id']).forEach(d =>
      {
        // Rebuild taskIds object
        const taskIds = [];
        this.tasks.forEach(t =>
        {
          const index = d.taskIds.findIndex(x => x === t.id);
          if (index >= 0)
          {
            taskIds.push(t);
          }
        });

        const conditionalWaitId = this.conditionalWaits.find(c => c.id === d.conditionalWaitId);
        const outcome = (conditionalWaitId !== undefined) ? conditionalWaitId.outcomes.find(o => o.outcome === d.outcome) : null;
        if (conditionalWaitId !== undefined)
        {
          this.mapOutcomes.set(conditionalWaitId.id, conditionalWaitId.outcomes);
        }
        // Find the selected priority
        const priority = this.listPriorities.filter(x => x.value === d.priority);
        const selectedPriority = priority.length === 1 ? priority[0] : null;
        const assignee = { id: d.assigneeId, name: d.assigneeName };

        this.addUpdateRule(d.id, d.name, d.version, RuleType.update, d.updateType, taskIds, assignee, selectedPriority, this.channel.id,
          conditionalWaitId, outcome);
      });
    }

    // If new, must add an entry rule entry to show up
    if (!entryRuleFound)
    {
      this.translate.get('NEW-ENROLLMENT-CRITERIA-DEFAULT-NAME').subscribe({
        next: (value) =>
        {
          // Create default entry rule if none found
          this.addEntryRule(null, value, 0, 0, this.channel.id);
        }
      });
    }

    this.channelForm.get('channelCategory').valueChanges.subscribe({ next: () => { this.setDashboardEnrollmentState(); } });
    this.channelForm.get('private').valueChanges.subscribe({ next: () => { this.setDashboardEnrollmentState(); } });
    this.channelForm.get('referral').valueChanges.subscribe({ next: () => { this.setPrivateState(); } });
    this.setPrivateState();
    this.setDashboardEnrollmentState();

    this.loading = false;
  }

  private setPrivateState(): void 
  {
    // When Referral is checked on a Channel set Private=true and disable it
    if (!this.disableFormControl())
    {
      if (this.disablePrivate()) 
      {
        this.private.disable();
        this.private.setValue(true);
      }
      else
      {
        this.private.enable();
        this.private.setValue(false);
      }
      this.private.updateValueAndValidity();
    }
  }

  private setDashboardEnrollmentState(): void 
  {
    if (!this.disableFormControl())
    {
      if (this.disabledDashboardEnrollment()) 
      {
        this.dashboardEnrollment.disable();
        this.dashboardEnrollment.setValue(false);
      }
      else
      {
        this.dashboardEnrollment.enable();
      }
      this.dashboardEnrollment.updateValueAndValidity();
    }
  }

  /**
   * Add new staff to grid
   */
  private addStaff(newStaffMember: User): void
  {
    this.newStaffMember = newStaffMember;
    // Add staff if not already present
    if (this.staff.findIndex(x => x.id === this.newStaffMember.id) === -1)
    {
      this.staff.unshift(this.newStaffMember);
      this.staff = sortBy(this.staff, ['name']);
      this.staffGrid.setData(this.staff);
    }
  }

  /**
   * Set the goals based on channel goals provided.
   *
   * @param goals Channel goals.
   */
  private setGoals(goals: any): void
  {
    this.goals = goals;
    this.goals.forEach(g =>
    {
      g.timeline = moment.duration(g.timeline).asDays();
    });
  }

  /**
   * Load the channel groups.
   *
   * @param groupIds List of groupIds
   * @param allGroups All groups
   */
  private setChannelGroups(groupIds: Array<number>, allGroups: Array<Group>): void
  {
    const groups = sortBy(allGroups.filter(g => groupIds.includes(g.id)), ['name']);
    this.channel.groups = groups;
  }

  /**
   * Load the channel users.
   *
   * @param userIds List of userIds
   * @param users All users
   */
  private setChannelUsers(userIds: Array<number>, allUsers: Array<User>): void
  {
    const users = sortBy(allUsers.filter((u: any) => userIds.includes(u.id) && !u.deleted), ['name']);
    const staff = [];

    if (users && users.length > 0)
    {
      users.forEach(d =>
      {
        const user = users.find(x => x.id === d.id);
        if (user)
        {
          staff.push(user);
        }
      }
      );
    }
    this.staff = staff;
    this.staffGrid.setData(staff);
    this.staffGrid.setSort([{ field: 'name', dir: 'asc' }]);
    this.channel.users = users;
  }

  /**
   * Get the users based on the selected group(s).
   *
   * @param users All users
   * @param groups All groups
   */
  private getSelectedUsersFromGroups(groups: Array<Group>, allGroups: Array<Group>): Array<User>
  {
    const staff = [];
    groups.forEach(g =>
    {
      const group = allGroups.find(x => x.id === g.id);
      if (group)
      {
        if (group.users)
        {
          group.users.forEach(u =>
          {
            const index = staff.findIndex(x => x.id === u.id);
            if (index === -1)
            {
              staff.push(u);
            }
          });
        }
      }
    });
    return staff;
  }
}
